import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {BadgeComponent} from './badge.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        BadgeComponent
    ],
    exports: [
        BadgeComponent
    ],
})
export class BadgeModule {}
